export default {
  API: "https://srv522487.hstgr.cloud", //Prod Nova Api
};
